import { useRouteError, Link } from "react-router-dom";
import '../../styles/components/pages/error-page.css';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="error-container">
      <h1 className="error-heading">Oops!</h1>
      <p className="error-message">Sorry, an unexpected error has occurred.</p>
      <p className="error-details">
        {error.statusText || error.message}
      </p>
      <Link to="/" className="error-link">Return to Homepage</Link>
    </div>
  );
}